import { blogCategoriesApi } from "@/apis/apis";
import MasterDataBaseTable from "@/pages/WebDataManagement/MasterData/MasterDataBaseTable";
import { columns } from "./Columns";
import BlogCategoryModal from "@/Modals/BlogManagement/Categories/Modal";

export default function BlogCategoriesPage() {
  return (
    <MasterDataBaseTable
      label="Blog Category"
      apiURL={blogCategoriesApi}
      columns={columns()}
      ModalComponent={BlogCategoryModal}
      enableSortData={true}
      enableExport={false}
    />
  );
}
